import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-scheduleManage",
  "use": "icon-scheduleManage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-scheduleManage\"><path d=\"M967.085829 291.141159v565.557913c0 54.951614-46.418755 99.550025-103.588912 99.550025H103.560469C46.447197 956.249097 0.028443 911.650686 0.028443 856.699072V291.141159h967.057386z m-273.051498 380.679295H273.07994a45.508583 45.508583 0 1 0 0 91.017166h420.954391a45.508583 45.508583 0 1 0 0-91.017166z m0-227.542914H273.07994a45.508583 45.508583 0 1 0 0 91.017166h420.954391a45.508583 45.508583 0 1 0 0-91.017166zM746.881173 0.056886c26.224321 0 47.499583 21.275262 47.499584 47.556469v22.583634h69.11616c57.170157 0 103.588912 44.541525 103.588912 99.550025v48.239098H0.028443v-48.239098c0-55.0085 46.418755-99.550025 103.588912-99.550025h69.11616V49.604355a49.54747 49.54747 0 1 1 99.094939 0v20.592634h427.49625V47.613355c0-26.281207 21.275262-47.556469 47.556469-47.556469z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/scheduleManage.svg
// module id = oEpU
// module chunks = 78